if (!Number.isNan) {
	Object.defineProperty(Number, 'isNaN', {
		value: function(value) {
			return value !== value;
		}
	});
}
// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function noop() {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

var Utils = {
	// limit the number of times a function can be run within a given time frame
	debounce: function(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},
	getURLParameter: function(name) {
		var rgexp = new RegExp(name + '=' + '(.+?)(&|$)');
		return decodeURIComponent( (rgexp.exec(window.location.search)||[,""])[1] );
	},
	getRandomInt: function(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	},
	getRandomArbitrary: function (min, max) {
		return Math.random() * (max - min) + min;
	},
	isTouchDevice: function(){
		if ('ontouchstart' in document.documentElement) {
			return true;
		}
		return false;
	},
	isRetina: function(){
		var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
            (min--moz-device-pixel-ratio: 1.5),\
            (-o-min-device-pixel-ratio: 3/2),\
            (min-resolution: 1.5dppx)";
		if (window.devicePixelRatio > 1) {
			return true;
		}
		if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
			return true;
		}
		return false;
	},
	arrayShuffle: function(array) {
		var i = 0
			, j = 0
			, temp = null;

		for (i = array.length - 1; i > 0; i -= 1) {
			j = Math.floor(Math.random() * (i + 1));
			temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	},
	centeredPopup: function (url, title, w, h) {
		// Fixes dual-screen position Most browsers Firefox
		var dualScreenLeft = (typeof window.screenLeft !== 'undefined') ? window.screenLeft : screen.left;
		var dualScreenTop = (typeof window.screenTop !== 'undefined') ? window.screenTop : screen.top;
		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		var left = ((width / 2) - (w / 2)) + dualScreenLeft;
		var top = ((height / 2) - (h / 2)) + dualScreenTop;
		var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

		// Puts focus on the newWindow
		if (window.focus) {
			newWindow.focus();
		}
	},
	isFunction: function(functionToCheck) {
		//return (typeof functionToCheck === 'function');
		return ( functionToCheck && {}.toString.call(functionToCheck) === "[object Function]" );
	},
	validEmail: function(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
};
